import { render, staticRenderFns } from "./HeaderSortTitle.vue?vue&type=template&id=9f12a662&scoped=true"
import script from "./HeaderSortTitle.vue?vue&type=script&lang=js"
export * from "./HeaderSortTitle.vue?vue&type=script&lang=js"
import style0 from "./HeaderSortTitle.vue?vue&type=style&index=0&id=9f12a662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f12a662",
  null
  
)

export default component.exports